export const createExternalId = (organization) => {
    switch (organization.sourceSystem.toUpperCase()) {
        case 'INS2000': return organization.sourceId;
        case 'CUSTOMERFORM': return 'KYC-Form';
        default: return organization.sourceSystem.toUpperCase();
    }
}